import { Stack } from "@mui/material";
import { trackPageViewV2 } from "@/services/analytics-adapter";
import {
  defaultFullscreenPageStyling,
  pageWithBottomNavigationStyling,
} from "@/theme";
import BottomNavigation from "@/features/Common/components/BottomNavigation";
import HealthScoreHeader from "../../components/HealthScoreHeader";

export interface HealthScorePageContainerProps {
  children?: React.ReactNode;
  showBottomNavigation?: boolean;
  healthScore?: number;
  title?: string;
  description?: string;
}

export default function HealthScorePageContainer({
  showBottomNavigation = false,
  healthScore,
  title,
  description,
  children,
}: HealthScorePageContainerProps) {
  return (
    <Stack>
      <HealthScoreHeader
        healthScore={healthScore}
        title={title}
        description={description}
        showInfoLink={!!healthScore && healthScore > 12}
      />
      <Stack
        sx={{
          ...defaultFullscreenPageStyling,
          ...pageWithBottomNavigationStyling,
          position: "relative",
          pl: 0,
          pr: 0,
          pt: 0,
        }}
      >
        <Stack
          paddingLeft={2}
          paddingRight={2}
          sx={{ flex: 1, overflow: "hidden" }}
        >
          {children}
        </Stack>
        {showBottomNavigation && <BottomNavigation />}
      </Stack>
    </Stack>
  );
}
